import React, { FC } from 'react';
import { isEmpty } from 'lodash';

import Column from 'components/common/Column';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import { Delivery } from 'types/api';
import CommonImage from 'components/common/CommonImage';
import { ICON_COPY_LIGHT_GRAY } from 'assets/icons';
import { formatPhoneNumber } from 'utils/formatting';

interface Props {
  selectedDelivery: Delivery;
}

const DeliveryInformation: FC<Props> = props => {
  const { selectedDelivery } = props;

  const replies =
    selectedDelivery?.order?.items?.[0]?.units?.[0]?.replies || [];

  return (
    <>
    <Row gap="16px" align="flex-start">
      <Column align="flex-start" gap="8px" style={{ width: 'auto' }}>
        <Text color="#46474C">닉네임</Text>
        <Text color="#46474C">이름</Text>
        <Text color="#46474C">번호</Text>
        <Text color="#46474C">우편번호</Text>
        <Column
          align="flex-start"
          justifyContent="flex-start"
          style={{ height: '40px' }}
        >
          <Text color="#46474C">주소</Text>
        </Column>
        <Text color="#46474C">상세주소</Text>
        <Text color="#46474C">전달사항</Text>
        <Text color="#46474C">구매옵션</Text>
      </Column>
      <Column align="flex-start" gap="8px" style={{ width: 'auto' }}>
        <Text color="#70737C" weight={400}>
          {selectedDelivery.customer.nickname}
        </Text>
        <Text color="#70737C" weight={400}>
          {selectedDelivery.recipient.name}
        </Text>
        <Row
          onClick={() => {
            navigator.clipboard.writeText(
              selectedDelivery.customer.mobileNumber,
            );

            window.showToast('연락처가 복사되었습니다.', 'success', 3000);
          }}
        >
          <Text color="#70737C" weight={400}>
            {formatPhoneNumber(selectedDelivery.customer.mobileNumber)}
          </Text>
          <CommonImage
            src={ICON_COPY_LIGHT_GRAY}
            style={{ marginLeft: '6px', pointerEvents: 'none' }}
          />
          <Text size="10px" weight={400}>
            복사
          </Text>
        </Row>
        <Row
          onClick={() => {
            navigator.clipboard.writeText(
              selectedDelivery.recipient.address.zoneCode,
            );

            window.showToast('우편번호가 복사되었습니다.', 'success', 3000);
          }}
        >
          <Text color="#70737C" weight={400}>
            {selectedDelivery.recipient.address.zoneCode}
          </Text>
          <CommonImage
            src={ICON_COPY_LIGHT_GRAY}
            style={{
              marginLeft: '6px',
              pointerEvents: 'none',
            }}
          />
          <Text size="10px" weight={400}>
            복사
          </Text>
        </Row>
        <Column align="flex-start" gap="6px" style={{ height: '40px' }}>
          <Text color="#70737C" weight={400}>
            {selectedDelivery.recipient.address.jibunAddress}
          </Text>
          <Text color="#70737C" weight={400}>
            [도로명] {selectedDelivery.recipient.address.roadAddress}
          </Text>
        </Column>
        <Text color="#70737C" weight={400}>
          {selectedDelivery.recipient.address.addressDetail
            ? selectedDelivery.recipient.address.addressDetail
            : '없음'}
        </Text>
        <Text color="#70737C" weight={400}>
          {selectedDelivery.recipient.note
            ? selectedDelivery.recipient.note
            : '없음'}
        </Text>
        {selectedDelivery.items.map(item => {
          return (
            <Text color="#70737C" weight={600} key={item.id}>
              {item.info.name} x {item.count}개
            </Text>
          );
        })}
      </Column>
    </Row>
    {!isEmpty(replies) && (
      <Column
        align="flex-start"
        gap="8px"
        style={{ width: '100%', marginTop: '-16px' }}
      >
        <Text color="#46474C" size="14px" weight={500}>
          추가정보
        </Text>
        <Column
          align="flex-start"
          gap="16px"
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #EAEBEC',
            borderRadius: '12px',
          }}
        >
          {replies.map((reply, idx) => {
            const hasSelections = !isEmpty(reply.selections);
            const hasAnswer = reply.answer && reply.answer !== '';

            let answerText = '-';
            if (hasSelections) {
              answerText = reply.selections.map(s => s.label).join(', ');
            } else if (hasAnswer) {
              answerText = reply.answer;
            }

            return (
              <React.Fragment key={idx}>
                <Column
                  align="flex-start"
                  gap="8px"
                  style={{ width: '100%' }}
                >
                  <Row
                    gap="12px"
                    align="flex-start"
                    justifyContent="flex-start"
                    style={{ width: '100%' }}
                  >
                    <Text
                      color="#414B56"
                      size="14px"
                      weight={500}
                      style={{ flexShrink: 0 }}
                    >
                      질문
                    </Text>
                    <Text
                      color="#70737C"
                      size="14px"
                      weight={400}
                      style={{ flex: 1 }}
                    >
                      {reply.title}
                    </Text>
                  </Row>
                  <Row
                    gap="12px"
                    align="flex-start"
                    justifyContent="flex-start"
                    style={{ width: '100%' }}
                  >
                    <Text
                      color="#414B56"
                      size="14px"
                      weight={500}
                      style={{ flexShrink: 0 }}
                    >
                      답변
                    </Text>
                    <Text
                      color="#70737C"
                      size="14px"
                      weight={400}
                      style={{ flex: 1 }}
                    >
                      {answerText}
                    </Text>
                  </Row>
                </Column>
                {idx < replies.length - 1 && (
                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAEBEC',
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </Column>
      </Column>
    )}
  </>
  );
};

export default DeliveryInformation;
